/**
 * Tipagem das configurações do window.configs
 */
export interface WindowConfigs {
  REACT_APP_API_KEY: string;
  REACT_APP_SITE_NOVO_URL: string;
  REACT_APP_SITE_ANTIGO_URL: string;
  REACT_APP_BASE_URL: string;
  REACT_APP_DASHBOARD_API: string;
  REACT_APP_BASE_URL_ANTIGO: string;
  REACT_APP_BASENAME: string;
  /**
   * "false" desliga o Dashboard neste ambiente (some do menu e deixa de ser página de entrada).
   * Ausente = ligado, para o pipeline da Alumisoft (index_pipeline.html) não mudar de comportamento.
   */
  REACT_APP_DASHBOARD_DISPONIVEL?: string;
}

declare global {
  interface Window {
    configs: WindowConfigs;
  }
}

/**
 * Validação básica de configurações
 */
function validateConfigs(): WindowConfigs {
  if (!window.configs) {
    throw new Error(
      'ERRO: window.configs não está definido!\n' +
      'Verifique se o bloco <script> existe em public/index.html'
    );
  }
  
  const required = ['REACT_APP_API_KEY', 'REACT_APP_BASE_URL', 'REACT_APP_BASE_URL_ANTIGO'];
  const missing = required.filter(key => window.configs[key as keyof WindowConfigs] === undefined || window.configs[key as keyof WindowConfigs] === null);
  
  if (missing.length > 0) {
    throw new Error(
      `ERRO: Configurações obrigatórias faltando em window.configs:\n` +
      missing.map(k => `  - ${k}`).join('\n')
    );
  }
  
  return window.configs;
}

const configs = validateConfigs();

/**
 * O Dashboard existe neste ambiente? Só é "false" quando o index.html publicado diz "false".
 *
 * Incidente de 05/09/2026: o módulo do Dashboard (Mof.Consulta.Api + tabelas do Mof.Processa)
 * nunca foi instalado no ambiente Azure da Faktory — e a base restaurada do cliente deu a usuários
 * a tela DashboardSistemista, que os levava direto para uma página que só devolve 500.
 */
export function dashboardDisponivel(): boolean {
  return String(configs.REACT_APP_DASHBOARD_DISPONIVEL ?? "true").trim().toLowerCase() !== "false";
}

export default configs;